"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./AreasItem.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AreasItem = function AreasItem(_ref) {
  var type = _ref.type,
      icon = _ref.icon,
      title = _ref.title,
      counter = _ref.counter;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-item"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-item-wraper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-item-head"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-areas-item-icon ' + type
  }, icon)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-item-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-title-areas"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-content-counter-areas"
  }, counter))));
};

AreasItem.propTypes = {
  type: _propTypes["default"].oneOf(['agent', 'admin', 'inbound', 'outbound']),
  icon: _propTypes["default"].string,
  title: _propTypes["default"].string,
  counter: _propTypes["default"].string
};
var _default = AreasItem;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/AreasItem/AreasItem.js
// module id = 1884
// module chunks = 0